export const fromUtf8 = input => new TextEncoder().encode(input);